var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 71,
    viewBox: "0 0 116 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M113.128 0.59154L3.32058 0.43822C1.87716 0.436204 0.705397 1.6047 0.703382 3.04812L0.612984 67.7911C0.610968 69.2345 1.77946 70.4063 3.22288 70.4083L113.03 70.5616C114.474 70.5636 115.645 69.3951 115.648 67.9517L115.738 3.20874C115.74 1.76531 114.571 0.593555 113.128 0.59154Z",
    fill: "#3098F3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.68701 2.95215C20.9826 14.4825 55.5737 34.9489 57.6491 35.929C59.7246 36.9091 64.5097 39.1383 66.2969 38.8692C69.2432 38.468 72.0469 37.3531 74.4643 35.6215C85.5911 28.0307 107.749 10.1971 113.014 4.87388",
    stroke: "#082C4E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon5);
export default __webpack_public_path__ + "static/media/icon5.399f842d95b6251f5cae79c46e55e8ac.svg";
export { ForwardRef as ReactComponent };